import React from 'react';

import './index.scss';

// eslint-disable-next-line react/prop-types
export default function ButtonSmall({ children }) {
  return (
    <div className="button-small">{ children }</div>
  );
}
